<template>
    <div class="py-0 mt-4 mb-8">
        <v-container class="mx-0 my-0" style="padding:0 !important; max-width: 100% !important">
            <v-card class="mt-1 pt-1 pb-10 px-0 size" style="margin-bottom: 35px !important" align="center" v-if="appointment != null">
                <v-row align="end" class="px-4 pb-3" justify="center">
                    <h3 class="px-4 pt-4 blue_accent--text" style="font-size:25px">{{ $t('register_in_portal.register_in_portal') }}</h3>
                </v-row>
                <v-col cols="6" justify="start" align="start" class="px-0">
                    <v-row>
                        <v-col cols="6" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text text--uppercase font-weight-bold" style="font-size:18px">
                                {{ $t('process_pendings.general_data') }} 
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.appointment') }}: </span> {{ this.id }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.client') }}: </span> {{ this.appointment.client.name }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.estimated_date_of_arriving') }}: </span> {{ this.appointment.arrival_date }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="$store.state.language == 'en'" cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.operation') }}: </span> {{ this.appointment.operation.description1 }} </v-col>
                        <v-col v-if="$store.state.language == 'es'" cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.operation') }}: </span> {{ this.appointment.operation.description }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.container') }}: </span> {{ this.appointment.container_number }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.description') }}: </span> {{ this.appointment.description }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('process_pendings.comments') }}: </span> {{ this.appointment.commentary }} </v-col>
                    </v-row>
                </v-col>
                <v-col class="py-5 px-0" cols="6" justify="start" align="start">
                    <v-row>
                        <v-col cols="12" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text font-weight-bold" style="font-size:18px">
                                {{ $t('process_pendings.products') }} 
                            </span>
                        </v-col>
                    </v-row>
                    <datatable :props="{headers:headers_sku, items: products}" @methodHandler="methodHandler"></datatable>   
                </v-col>

                <v-col cols="6" justify="center" align="center" class="px-0 mx-0">
                    <v-autocomplete class="px-0 mx-0" v-model="gate_id" :items="portals" item-text="name" item-value="id" :rules="rules_required" :label="$t('register_in_portal.select_ramp')"></v-autocomplete>
                </v-col>
                
                <v-col cols="6" justify="center" align="center">
                    <v-row align="end" justify="end">
                        <btn-sf :label="'register_in_portal.cancel'" class="mr-2" @click="cancel"></btn-sf>
                        <btn-sf :label="'register_in_portal.to_pending'" class="mr-2" @click="toPending" v-permission="'op_pendings.update'"></btn-sf>
                        <btn-sf :label="'register_in_portal.save'" class="mr-2" @click="update('on-ramp')" :disabled="gate_id == ''" v-permission="'op_on_premises.update'"></btn-sf>
                        <btn-pf :label="'register_in_portal.save_and_continue'" @click="update('start-processing')" :disabled="gate_id == ''" v-permission="'op_on_premises.update'"></btn-pf>
                    </v-row>
                </v-col>
            </v-card>
            <bottom-bar ref="bottombar" :from="from" :m_type="m_type"></bottom-bar>
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>

import { appointmentShowUseCase } from '../../application/use_cases/appointment_show_use_case';
import { appointmentSetStatusUseCase } from '../../application/use_cases/appointment_set_status_use_case';
import { HttpAppointmentRepository } from '../../infrastructure/appointment_repository';
import { freeGatesUseCase } from '../../../gates/application/use_cases/free_gates_use_case';
import { HttpGateRepository } from '../../../gates/infrastructure/repositories/gate_repository'

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('edit_appointment.validations.required_field')]}, 
        headers_sku: function(){
            return [
                {text: this.$t('process_pendings.sku'), value: 'sku_p', class: 'text-uppercase'},
                // {text: this.$t('edit_appointment.description'), value: 'descripcion', class: 'text-uppercase'},
                {text: this.$t('process_pendings.pieces'), value: 'quantity', class: 'text-uppercase'},
                {text: this.$t('process_pendings.unit'), value: 'unit', class: 'text-uppercase'}
            ];
        }
    },
    data(){
        return {
            id: this.$route.params.id,
            from: this.$route.params.from,
            m_type: this.$route.params.m_type,
            snackbar: {
                visible: false,
                color: 'primary',
                timeout: 2000,
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            products: [],
            gate_id: "",
            appointment: null,            
            portals: [],
        }
    },
    mounted(){
        this.index();
        localStorage.setItem('bottom', 1);
        this.$store.state.module = "headers.in_portal_operation";
        this.$store.state.bottom = 1;
    },
    methods: {
        back(){
            this.$router.push({ name: 'OperationOnEnclosure' });
        },
        methodHandler(object){
            this[object.methodName](object.parameters);
        },
        async index(){
            try{
                this.appointment = await appointmentShowUseCase(this.id, HttpAppointmentRepository);
                this.portals = await freeGatesUseCase(HttpGateRepository);

                await this.loadProducts();
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async loadProducts() {
            if(this.appointment.operation.format_type == "Entrada"){
                if(this.appointment.unknown_products == true){
                    var p = {};
                    if(this.appointment.standby_products[0].attributes.unknownProducts.boxes > 0){
                        console.log("OKOKK")
                        p = {
                            sku_p: this.$t('process_pendings.boxes'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.boxes
                        }
                        this.products.push(p);
                    }
                    else if(this.appointment.standby_products[0].attributes.unknownProducts.pallets > 0){
                        p = {
                            sku_p: this.$t('process_pendings.pallets'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.pallets
                        }
                        this.products.push(p);
                    }
                    else if(this.appointment.standby_products[0].attributes.unknownProducts.containers > 0){
                        p = {
                            sku_p: this.$t('process_pendings.containers'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.containers
                        }
                        this.products.push(p);
                    }
                }
                else{
                    this.appointment.standby_products.forEach(x => 
                    {
                        x = x.attributes;
                        var p = {};
                        p = {
                            sku_p: x.product.sku,
                            quantity: x.quantity,
                            unit: x.product.unit
                        }
                                    
                        this.products.push(p);
                    });
                }
            } 
            else if(this.appointment.operation.format_type == "Salida"){
                this.appointment.detail_orders.forEach(x => 
                {
                    x = x.attributes;
                    var p = {};
                    p = {
                        sku_p: x.product.sku,
                        quantity: x.expected,
                        unit: x.product.unit
                    }
                                
                    this.products.push(p);
                });
            }
        },
        async update(url){
            if(this.gate_id != null && this.gate_id != ''){
                try{
                    const appointment = {
                        gate_id: this.gate_id,
                        status: 'En rampa',
                        newStatus: 'En rampa',
                    }
                    const res = await appointmentSetStatusUseCase(this.id, appointment, HttpAppointmentRepository);
                    res;
                    
                    if(url== "on-ramp") this.$router.push('/operation/' + url + '/' + this.from + '/' + this.m_type);
                    else this.$router.push('/operation/' + url + '/' + this.id + '/' + this.from + '/' + this.m_type);
                } catch (e) {
                    console.log(e);
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response.data.message
                    }
                }
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('register_in_portal.responses.empty')
                }
            }
        },
        async toPending(){
            try{
                const appointment = {
                    gate_id: null,
                    status: 'Pendiente',
                    newStatus: 'Pendiente',
                }
                
                const res = await appointmentSetStatusUseCase(this.id, appointment, HttpAppointmentRepository);
                res;
                
                this.$router.push('/operation/pendings/' + this.from + '/' + this.m_type);
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.message
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        }
    },
    watch:{}
}
</script>

<style lang="css">
.size{
    min-height: calc(100vh - 120px) !important;
    position:relative !important;
}
</style>